import React, { useEffect, useRef, useState } from "react";
import { regionSpecificGioDistanceInputField } from "../../../features/updateGeofence/updateGeofenceTypes";
import { TextField, Button } from "@mui/material";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../../providers/TranslationProvider";
import "./attendance.css";
import { ConfirmationPopUp } from "../../popup/confirmationPopUp";
import { getAttendanceDataFromConfig, saveAttendanceData } from "../../../features/updateGeofence/updateGeofenceService";
import { popupType } from "../../../types/types";
import { GenericPopUp } from "../../popup/genericPopUp";
import { Loader } from "../../loader/Loader";
const Attendance: React.FC = () => {
  const { translate } = usePortalTranslation();
  const [formValues, setFormValues] = useState<{ [key: string]: string }>({});
  const [confirmationPopUp, setConfirmationPopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [loading,setLoading] = useState<boolean>(false);

  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

  const popUpSuccessMethod = useRef<any>();

  const updateConfirmationPopData = (message: string, methodHelper: any) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };

  const openPopUp = (message: string, modalType: popupType) => {
    setGenericModalSMessage(message);
    setGenericModalState(true);
    setGenericModalType(modalType);
  };

  const initializeFormValues = (inputFieldsOptions : regionSpecificGioDistanceInputField[]) => {
    const initialValues = inputFieldsOptions.reduce((acc, option) => {
      acc[option.region] = String(option.distance)  || ""; // Set initial distance value, or 0 if not provided
      return acc;
    }, {} as { [key: string]: string });

    setFormValues(initialValues);
  };
  const resetFormValues = () => {
    const newFormValues = Object.keys(formValues).reduce((acc, key) => {
      acc[key] = ""; // Reset all values to 0
      return acc;
    }
    , {} as { [key: string]: string });
    setFormValues(newFormValues);
  }
  const init = async () => {
    setLoading(true);
    const errors: string[] = []; // Array to collect error messages

    try {
        const response = await Promise.allSettled([
            getAttendanceDataFromConfig(), // Add other API calls here
        ]);

        // Iterate over the results and collect error messages
        response.forEach((res, index) => {
            if (res.status === "rejected") {
                // Add the name of the API call to the errors array
                if (index === 0) {
                    errors.push(translate(TranslationEnum.geofence,"Attendance Data"));
                } else {
                    errors.push(`API Call ${index + 1}`); // Generic message if no specific case
                }
            }
            else {
              if (index === 0) {
                initializeFormValues(res.value);
              }
            }
        });

        // Show popup if there were any errors
        if (errors.length > 0) {
          openPopUp(`${translate(TranslationEnum.common_portal,"There was an error in:")} ${errors.join(", ")}`, "Error");
        }

    } catch (error) {
        console.error("Unexpected error occurred:", error);
        openPopUp(translate(TranslationEnum.common_portal,"Something Went Wrong"), "Error"); // Handle unexpected errors
    } finally {
        setLoading(false); // Stop loading regardless of outcome
    }
};
  // This effect initializes values in the formValues state
  useEffect(() => {
    init();
  }, []);

  // Handle input change for each field
  const handleInputChange =
    (region: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      // const value = Number(event.target.value);
      // if (!isNaN(value)) {
        setFormValues((prevValues) => ({
          ...prevValues,
          [region]: event.target.value,
        }));
      // }
    };
  const handleAttendanceSubmitRequest = async () => {
    try{
      const formattedFormValues : regionSpecificGioDistanceInputField[] = Object.keys(formValues).map((key) => ({
        region: key,
        distance: Number(formValues[key]),
      }));
      await saveAttendanceData(formattedFormValues , openPopUp);
 
    }
    catch{
      openPopUp(translate(TranslationEnum.common_portal,"Error saving data"), "Error");
      console.error("Error saving attendance data");
    }
  };
  const handleSave = () => {
    // Save logic here
    setConfirmationPopUp(true);
    updateConfirmationPopData(
      translate(TranslationEnum.common_portal,"Are you sure want to save ?"),
      handleAttendanceSubmitRequest
    );
  };

  const handleCancel = () => {
    // Cancel logic here
    setConfirmationPopUp(true);
    updateConfirmationPopData(
      translate(TranslationEnum.common_portal,"Are you sure want to cancel ? All unsaved changes will be lost!"),
      resetFormValues
    );
  };

  return (
    <>
  { loading? <Loader/> : ( <div className="updateGeofence-attendance-wrapper">
      <div className="updateGeofence-attendance-formInputs-wrapper">
        {Object.keys(formValues).map((key) => (
          <div
            key={key}
            className="updateGeofence-attendance-formInput"
          >
            <div className="updateGeofence-attendance-formInput-label">
              {translate(TranslationEnum.geofence, key)}
            </div>
            <TextField
              className="updateGeofence-attendance-formInput-input"
              id={`geofence-distance-${key}`} // Unique ID for each input
              label={translate(TranslationEnum.geofence, "Distance (in meters)")} // Translate each region
              variant="outlined"
              type="text" // Ensure the input type is number
              value={formValues[key] || ""} // Controlled input
              onChange={handleInputChange(key)} // Handle changes
              InputProps={{
                inputProps: {
                  min: 0,
                  inputMode: "numeric",
                  pattern: "[0-9]*", // This won't work with input type="number"
                },
              }}
            />
          </div>
        ))}
      </div>
      <div className="updateGeofence-buttons-wrapper">
        <Button
          variant="contained"
          onClick={handleSave}
          // className="updateGeofence-save-button"
        >
          {translate(TranslationEnum.common, "Save")}
        </Button>
        <Button
          // className="updateGeofence-cancel-button"
          variant="contained"
          onClick={handleCancel}
        >
          {translate(TranslationEnum.common, "Cancel")}
        </Button>
      </div>
      <ConfirmationPopUp
        openConfirmModal={confirmationPopUp}
        message={popUpMessage}
        setOpenConfirmModal={() => {
          setConfirmationPopUp(false);
        }}
        successMethod={popUpSuccessMethod.current}
      />
      <GenericPopUp
          type={genericModaltype}
          message={genericModalMessage}
          openGenericModal={genericModalState}
          setOpenGenericModal={() => {
            setGenericModalState(false);
          }}
        />
    </div>)}
    </>

  );
};

export default Attendance;
